import { createAction, props } from '@ngrx/store';
import { IBaseTab, ITabDashboard, ITabReport } from '../model/report-tabs.model';

export enum TabsActionTypes {
    Add = '[Report Tabs] Add',
    Close = '[Report Tabs] Close',
    DataLoaded = '[Report Tabs] Data Loaded',
    ReportLoadedById = '[Report Tabs] Report Loaded By ID',
    Saved = '[Report Tabs] Saved',
    SwitchTab = '[Report Tabs] Switch',
    SwitchToLastTab = '[Report Tabs] Auto switch to the last available tab',
    SetUnsaved = '[Report Tabs] Set Unsaved',
    SetToClosed = '[Report Tabs] Set Tab As Closed',
    UpdateTabInfoData = '[Report Tabs] Update Tab Info Data'
}

export const addTabAction = createAction(TabsActionTypes.Add, props<{ tab: IBaseTab<ITabReport | ITabDashboard> }>());
export const addTabActionSuccess = createAction(TabsActionTypes.Add, props<{ id: string }>());
export const closeTabAction = createAction(TabsActionTypes.Close, props<{ id: string }>());

export const switchTabAction = createAction(TabsActionTypes.SwitchTab, props<{ id: string }>());
export const savedTabAction = createAction(TabsActionTypes.Saved, props<{ name: string; reportUUID?: string }>());
export const dataLoadedTabAction = createAction(TabsActionTypes.DataLoaded, props<{ reportUUID: string; name: string }>());
export const reportLoadedByIdTabAction = createAction(TabsActionTypes.ReportLoadedById, props<{ reportUUID: string; name: string }>());
export const setUnsavedTabAction = createAction(TabsActionTypes.SetUnsaved, props<{ reportUUID: string }>());
export const updateTabInfoData = createAction(TabsActionTypes.UpdateTabInfoData, props<{ reportId: string; reportUUID: string }>());
export const setToClosed = createAction(TabsActionTypes.SetToClosed, props<{ id: string }>());

export const switchToLastTab = createAction(TabsActionTypes.SwitchToLastTab);
